import { memo, useContext, useEffect, useState } from "react";
import { Button, DropdownButton, Form, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import { makeid } from "utils/random";
import { NewTableContext } from ".";
import { IColumnNewTable } from "./interfaces";
import Icon from "components/Icon";

interface ITableTopBarProps{
  onChange: Function;
  export?: boolean;
  exportSelectColumns?: boolean;
  columns?: IColumnNewTable[];
}

function TableTopBar({onChange, ...props}:ITableTopBarProps){
  const changeDefault = {
    per_page:{change:false,value:10},
    __search:{change:false,value:null}
  }
  const [loadExport, setLoadExport] = useState(false);
  const [ columnsSelected, setColumnsSelected ] = useState(()=>{
    if(props.columns){
      let aux = [];
      for (let i = 0; i < props.columns.length; i++) {
        aux.push(true)
      }
      return aux;
    }

    return []; 
  });
  const { exportData } = useContext(NewTableContext);
  const [ ID ] = useState(`drop-${makeid(5)}-${makeid(5)}`);

  useEffect(()=>{
    if(props.columns){
      let aux = [];
      for (let i = 0; i < props.columns.length; i++) {
        aux.push(true)
      }
      setColumnsSelected(aux);
    }
  },[props.columns])

  const renderTooltip = (props:any) => (
    <Tooltip id="button-tooltip" {...props}>
      Exportar dados
    </Tooltip>
  );

  return (
  <div className="new-table-topbar-area">
    <div className="new-table-topbar">
      <Form.Group className="new-table-topbar-item">
        <Form.Label>Registros por página:</Form.Label>
        <Form.Select size="sm" onChange={({currentTarget})=>{
          currentTarget.blur()
          onChange({...changeDefault,per_page:{change:true,value:parseInt(currentTarget.value)}});
        }}>
          <option value={10} >10 </option>
          <option value={25} >25 </option>
          <option value={50} >50 </option>
          <option value={100}>100</option>
        </Form.Select>
      </Form.Group>
      <Form.Group className="new-table-topbar-item">
        <Form.Label>Pesquisa:</Form.Label>
        <Form.Control size="sm" onChange={({currentTarget})=>{
          onChange({...changeDefault,__search:{change:true,value:currentTarget.value}});
        }}/>
      </Form.Group>
    </div>
    {props.export?(
      <div className="new-table-topbar new-table-topbar-auto" style={{marginLeft: "10px"}}>
        <OverlayTrigger
          placement="right"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip}
        >
          <Button size="sm" className="new-table-topbar-item" disabled={loadExport} onClick={async ({currentTarget})=>{
            setLoadExport(true);
            currentTarget.blur()
            if(exportData) await exportData();
            setLoadExport(false);
          }}>
            {loadExport?<Spinner size="sm" animation="border" />:<Icon name="download"/>}
          </Button>
        </OverlayTrigger>
      </div>
    ):""}
    {props.exportSelectColumns?(
      <div className="new-table-topbar new-table-topbar-auto" style={{marginLeft: "10px"}}>
        <OverlayTrigger
          placement="right"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip}
        >
          <DropdownButton size="sm" 
            className="new-table-topbar-item" 
            disabled={loadExport} 
            title={loadExport?<Spinner size="sm" animation="border" />:<Icon name="download"/>}
            drop={"start"}
            autoClose={"outside"}
            id={ID}
          >
            {props.columns?props.columns.map((column, key)=>{
              return (
                <div className={"dropdown-item"} key={key}>
                  <input type="checkbox" checked={columnsSelected[key]}
                    onChange={(e)=>{
                      setColumnsSelected((old)=>{
                        let aux = [...old];
                        aux[key] = e.currentTarget.checked;
                        return aux;
                      })
                    }}
                  /> 
                  {column.text}
                </div>
              )
            }):<></>}
            <div className={"dropdown-item"}>
              <Button size="sm" className="new-table-topbar-item" disabled={loadExport} onClick={async ({currentTarget})=>{
                setLoadExport(true);
                let b = document.getElementById(ID);
                if(b){
                  b.click();
                }
                currentTarget.blur()
                if(exportData) await exportData(columnsSelected);
                setLoadExport(false);
              }}>
                {loadExport?<Spinner size="sm" animation="border" />:<Icon name="download"/>}
              </Button>
            </div>
            {/* <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
            <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
            <Dropdown.Item href="#/action-3">Something else</Dropdown.Item> */}
          </DropdownButton>
          {/* <Button size="sm" className="new-table-topbar-item" disabled={loadExport} onClick={async ({currentTarget})=>{
            setLoadExport(true);
            currentTarget.blur()
            if(exportData) await exportData();
            setLoadExport(false);
          }}>
            {loadExport?<Spinner size="sm" animation="border" />:<FontAwesomeIcon icon={icon("download")}/>}
          </Button> */}
        </OverlayTrigger>
      </div>
    ):""}
  </div>
  );
}

export default memo(TableTopBar);